import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { useOidc } from '@axa-fr/react-oidc';

export default function Header() {
  const { logout } = useOidc();

  return (
    <header className="page-header">
      <Container>
        <div className="row">
          <div className="col-8">
            <a
              href="https://www.pmi.org/"
              className="pmi-logo"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="Link-project"
            >
              Project Management Institute
            </a>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center align-content-center justify-content-end">
              <span>
                <Button
                  onClick={() => logout()}
                  className="log-out-link btn btn-link"
                  data-testid="Button-logout"
                >
                  <strong>Logout</strong>
                </Button>
              </span>
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
}
